import { render, staticRenderFns } from "./contracts-register-list.vue?vue&type=template&id=86608a08"
import script from "./contracts-register-list.vue?vue&type=script&lang=js"
export * from "./contracts-register-list.vue?vue&type=script&lang=js"
import style0 from "./contracts-register-list.vue?vue&type=style&index=0&id=86608a08&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports